<div class="container">
    <div class="card">
        <div class="card-body">
            <div class="panel panel-primary">
                <div class="panel-heading custom-panel">
                    <div class="titulo-painel-left">
                        <h2>Atendimentos (Exames)</h2>
                    </div>
                </div>
                <div class="panel-body" (window:resize)="onResize($event)">
                    <form [formGroup]="formularioDeAtendimentoProcedimentos" (ngSubmit)="onSubmit()">
                        <div class="form-row">
                            <mat-form-field class="form-group col-lg-9 col-md-9 col-sm-8 col-12">
                                <mat-label>Filial</mat-label>
                                <mat-select value="Filial" formControlName="idFilial" name="idFilial" id="idFilial"
                                    required>
                                    <mat-option *ngFor="let filial of listaFiliais" [value]="filial.id">
                                        {{filial.nome}}
                                    </mat-option>
                                </mat-select>
                                <mat-error
                                    *ngIf="formularioDeAtendimentoProcedimentos.controls.idFilial.hasError('required')">
                                    O campo Filial é obrigatório.
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field class="form-group col-lg-3 col-md-3 col-sm-4 col-12">
                                <mat-label>Data</mat-label>
                                <input matInput [matDatepicker]="dataMarcacaoDP" formControlName="dataMarcacao"
                                    id="dataMarcacao" name="dataMarcacao">
                                <mat-datepicker-toggle matSuffix [for]="dataMarcacaoDP"></mat-datepicker-toggle>
                                <mat-datepicker #dataMarcacaoDP></mat-datepicker>

                                <mat-error
                                    *ngIf="formularioDeAtendimentoProcedimentos.controls.dataMarcacao.hasError('required')">
                                    O campo Data é obrigatório.
                                </mat-error>

                                <mat-error
                                    *ngIf="formularioDeAtendimentoProcedimentos.controls.dataMarcacao.hasError('invalidDate')">
                                    O campo Data está inválido.
                                </mat-error>
                            </mat-form-field>

                        </div>

                        <div class="form-row">
                            <mat-form-field class="form-group col-lg-9 col-md-9 col-sm-8 col-12">
                                <mat-label>Médico</mat-label>
                                <mat-select value="Médico" formControlName="idMedico" name="idMedico" id="idMedico">
                                    <mat-option [value]=""></mat-option>
                                    <mat-option *ngFor="let medico of listaMedicos" [value]="medico.id">
                                        {{medico.nome}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <div class="form-group col-lg-3 col-md-3 col-sm-4 col-12" style="align-self: center;">
                                <button mat-raised-button color="success" type="submit" matTooltip="Consultar"
                                    [disabled]="!formularioDeAtendimentoProcedimentos.valid" style="width: 100%;">
                                    Consultar
                                </button>
                            </div>
                        </div>
                    </form>

                    <div class="form-row">
                        <div class="form-group col-lg-7 col-md-6 col-sm-12 col-12">
                            <mat-form-field fxFlex="100%">
                                <input matInput type="text" (keyup)="doFilter($event)" placeholder="Filtrar"
                                    id="textFilter" name="textFilter">
                            </mat-form-field>
                        </div>

                        <div class="form-group col-lg-5 col-md-6 col-sm-12 col-12" style="padding: 0px; margin: 0px;">
                            <mat-grid-list cols="3" rowHeight="30px" class="bloco-totais">
                                <mat-grid-tile class="bloco-totais-total">Total: {{totalMarcacoes}}</mat-grid-tile>
                                <mat-grid-tile class="bloco-totais-agendados">Agendados: {{totalMarcacoesAgendadas}}
                                </mat-grid-tile>
                                <mat-grid-tile class="bloco-totais-atendidos">Atendidos: {{totalMarcacoesAtendidadas}}
                                </mat-grid-tile>
                                <mat-grid-tile></mat-grid-tile>
                                <mat-grid-tile class="bloco-totais-cancelados">Cancelados: {{totalMarcacoesCanceladas}}
                                </mat-grid-tile>
                                <mat-grid-tile class="bloco-totais-faltas">Faltas: {{totalFaltas}}</mat-grid-tile>
                            </mat-grid-list>
                        </div>
                    </div>

                    <table mat-table [dataSource]="dataSource" matSort class="table table-striped">
                        <ng-container matColumnDef="horaAtendimento">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Hora Atd. </th>
                            <td mat-cell *matCellDef="let marcacaoDTO"> {{marcacaoDTO.horaAtendimento |
                                horaFormatadaPipe}} </td>
                        </ng-container>

                        <ng-container matColumnDef="nomePaciente">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Paciente </th>
                            <td mat-cell *matCellDef="let marcacaoDTO"> {{marcacaoDTO.nomePaciente}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="indTitular">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Titular </th>
                            <td mat-cell *matCellDef="let marcacaoDTO"> {{marcacaoDTO.indTitular}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="cpf">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> CPF </th>
                            <td mat-cell *matCellDef="let marcacaoDTO"> {{marcacaoDTO.cpf | mask: '999.999.999-99'}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="nomePlanoSaude">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Convênio </th>
                            <td mat-cell *matCellDef="let marcacaoDTO"> {{marcacaoDTO.nomePlanoSaude}} </td>
                        </ng-container>

                        <ng-container matColumnDef="nomeProcedimento">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Exame </th>
                            <td mat-cell *matCellDef="let marcacaoDTO"> {{marcacaoDTO.nomeProcedimento}} </td>
                        </ng-container>

                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef class="table-column-center" mat-sort-header> Status
                            </th>
                            <td mat-cell *matCellDef="let marcacaoDTO" class="table-column-center">
                                <mat-icon class="mat-18 custom-cursor" color="{{marcacaoDTO.getCorStatusMarcacao()}}"
                                    style="vertical-align: middle;"
                                    matTooltip="{{marcacaoDTO.getTooltipStatusMarcacao()}}"
                                    (click)="executarAcaoDoStatusSelecionado(marcacaoDTO)">
                                    {{marcacaoDTO.getIconeStatusMarcacao()}}
                                </mat-icon>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="detalhe">
                            <th mat-header-cell *matHeaderCellDef class="table-column-center"> Detalhe </th>
                            <td mat-cell *matCellDef="let marcacaoDTO" class="table-column-center">
                                <mat-icon class="mat-18" color="{{marcacaoDTO.getCorCobrarAtendimento()}}"
                                    style="vertical-align: middle;"
                                    matTooltip="{{marcacaoDTO.getTooltipCobrarAtendimento()}}">
                                    {{marcacaoDTO.getIconeCobrarAtendimento()}}
                                </mat-icon>
                                <mat-icon class="mat-18" color="{{marcacaoDTO.getCorPNE()}}"
                                    style="vertical-align: middle;" matTooltip="{{marcacaoDTO.getTooltipPNE()}}">
                                    {{marcacaoDTO.getIconePNE()}}
                                </mat-icon>
                                <mat-icon class="mat-18" color="{{marcacaoDTO.getCorPeriodoVolta()}}"
                                    style="vertical-align: middle;"
                                    matTooltip="{{marcacaoDTO.getTooltipPeriodoVolta()}}">
                                    {{marcacaoDTO.getIconePeriodoVolta()}}
                                </mat-icon>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="acoes">
                            <th mat-header-cell *matHeaderCellDef class="table-column-center"> Ações </th>
                            <td mat-cell *matCellDef="let marcacaoDTO" class="table-column-center">
                                <button mat-icon-button color="primary" (click)="details(marcacaoDTO)"
                                    matTooltip="Info">
                                    <mat-icon class="mat-18">info</mat-icon>
                                </button>
                                <button mat-icon-button color="warn" (click)="cancelar(marcacaoDTO)"
                                    matTooltip="Cancelar">
                                    <mat-icon class="mat-18">cancel</mat-icon>
                                </button>
                                <button mat-icon-button color="warn" (click)="confirmDelete(marcacaoDTO)"
                                    matTooltip="Remover" [hidden]="ocultarOpcaoExcluir">
                                    <mat-icon class="mat-18">delete</mat-icon>
                                </button>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>